/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/FederationDetails" />
import React = require("react");
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { getFederationIssuer, getFederationSubject } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/ServiceEndpointExtensions";
import { IVssComponentContext, VssComponent, css } from "VSS/Platform/Layout";
import { copyToClipboard } from "VSSUI/Clipboard";
import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";

interface IFederationDetailsState {
    subject: string;
    issuer: string;
}

export class FederationDetails extends VssComponent<{}, IFederationDetailsState> {

    private readonly _endpointEditorStore: EndpointsEditorStore;

    constructor(context: IVssComponentContext) {
        super(context);

        this._endpointEditorStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);
        this._endpointEditorStore.addChangedListener(this._onStoreChange);

        const endpoint = this._endpointEditorStore.getEndpointClone();

        this.state = {
            subject: getFederationSubject(endpoint),
            issuer: getFederationIssuer(endpoint)
        };
    }

    public componentWillUnmount(): void {
        this._endpointEditorStore.removeChangedListener(this._onStoreChange);
    }

    public render(): JSX.Element {
        return (<React.Fragment>
            {this.renderFederationIssuer()}
            {this.renderFederationSubject()}
        </React.Fragment>);
    }

    private renderFederationIssuer(): JSX.Element {
        const issuer = this.state.issuer;
        return (<FormItem
            className={css("endpoint-editor-panel-text-box", "default-input-margin-top")}
            label={Resources.WorkloadIdentityFederationIssuerLabel}
            ariaLabel={Resources.WorkloadIdentityFederationIssuerLabel}
        >
            <TextField
                value={issuer}
                inputType={"text"}
                readOnly
                className="federation-issuer-input"
                suffixIconProps={{
                    onClick: () => copyToClipboard(issuer),
                    iconName: "Copy"
                }} />

        </FormItem>);
    }

    private renderFederationSubject(): JSX.Element {
        const subject = this.state.subject;
        return (<FormItem
            className={css("endpoint-editor-panel-text-box", "default-input-margin-top")}
            label={Resources.WorkloadIdentityFederationSubjectLabel}
            message={Resources.WorkloadIdentityFederationSubjectDescription2}
            ariaLabel={Resources.WorkloadIdentityFederationSubjectLabel}
        >
            <TextField
                value={subject}
                inputType={"text"}
                readOnly
                className="federation-subject-input"
                suffixIconProps={{
                    onClick: () => copyToClipboard(subject),
                    iconName: "Copy"
                }} />

        </FormItem>);
    }

    private _onStoreChange = (): void => {
        const endpoint = this._endpointEditorStore.getEndpointClone();
        this.setState({
            subject: getFederationSubject(endpoint)
        });
    }
}
